import { Guid } from "guid-typescript";
import { SmsMessage } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "SmsMessage";
export const SmsMessageService = {
	endpoint,
	createSingle: async (data: SmsMessage) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: SmsMessage) => await Service.updateSingleById(endpoint, id, data)
}